import React, { useState } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import logoUrl from "./assets/iflet.png";
const SignIN = () => {
  const [email, setEmail] = useState();
  const [userName, setUserName] = useState();
  const navigate = useNavigate();

  const handleLoginSuccess = (response) => {
    const credential = response.credential;
    const decodedToken = JSON.parse(atob(credential.split(".")[1]));

    setEmail(decodedToken.email);
    setUserName(decodedToken.name);
    sessionStorage.setItem("email", decodedToken.email);
    sessionStorage.setItem("userName", decodedToken.name);
    navigate("/chat");
  };

  const handleLoginFailure = (error) => {
    console.log("Google Login Failed:", error);
  };

  return (
    <GoogleOAuthProvider clientId="916209371470-p95i4736a0dn98j0v95nlap0fbo13jbu.apps.googleusercontent.com">
      <div className="flex min-h-svh flex-col items-center justify-center bg-background text-foreground font-sans px-4">
        <div className="flex w-full max-w-[320px] flex-col items-center gap-6 text-center">
          <img
            src={logoUrl}
            alt="Iflekt"
            className="w-auto mb-4"
            style={{ marginTop: "-50px" }}
          />
          <div className="space-y-2">
            <h1 className="text-3xl font-semibold tracking-tight">Welcome back</h1>
            <p className="text-sm text-muted-foreground">
              Sign in to continue to Iflekt
            </p>
          </div>

          <div className="flex w-full flex-col gap-4 mt-2">
            <div className="flex w-full justify-center">
              <GoogleLogin
                onSuccess={handleLoginSuccess}
                onError={handleLoginFailure}
                scope="email profile"
                theme="outline"
                size="large"
                shape="rectangular"
                width="320"
              />
            </div>

            <p className="mt-6 text-xs text-muted-foreground">
              By continuing, you agree to our <a href="#" className="underline underline-offset-4 hover:text-foreground">Terms of Service</a> and <a href="#" className="underline underline-offset-4 hover:text-foreground">Privacy Policy</a>.
            </p>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default SignIN;
